import React from "react";
import { Avatar, Blockquote, SimpleGrid, Group, Stack, Text } from "@mantine/core";
import { testimonials } from "#root/database/testimonials";
import { IconQuote } from "@tabler/icons-react";

export default function TestimonialsBlockquote() {
  return (
    <Stack>
      <SimpleGrid
        cols={{ base: 1, sm: 2, lg: 5 }}
        spacing={{ base: 10, sm: "xl" }}
        verticalSpacing={{ base: "md", sm: "xl" }}
      >
        {testimonials.map(({ id, name, testimonial }) => (
          <Blockquote
            key={id}
            iconSize={30}
            icon={<IconQuote />}
            color="blue"
            radius="xl"
            cite={
              <Group gap="sm">
                <Avatar
                  src={`https://xsgames.co/randomusers/avatar.php?g=female&id=${id}`}
                  alt={`Avatar of ${name}`}
                  radius="sm"
                  size="lg"
                />

                <Text fw={500}>{name}</Text>
              </Group>
            }
          >
            {testimonial}
          </Blockquote>
        ))}
      </SimpleGrid>
    </Stack>
  );
}
